import { FC } from "react";
import { SegmentedControl, SpaceBetween } from "@cloudscape-design/components";
import { formatQuarterHeader, getStartOfQuarter } from "../utils/date";

export type ViewMode = "month" | "quarter" | "year";

interface Props {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  activeDate: Date;
  handlePeriodChange: (dir: "prev" | "next") => void;
  loading?: boolean;
}

const PeriodFilterControls: FC<Props> = ({
  viewMode,
  setViewMode,
  activeDate,
  handlePeriodChange,
  loading = false,
}) => {
  return (
    <SpaceBetween size="l" direction="horizontal">
      <SegmentedControl
        selectedId={viewMode}
        onChange={({ detail }) => setViewMode(detail.selectedId as ViewMode)}
        label="View mode"
        options={[
          { text: "Month", id: "month" },
          { text: "Quarter", id: "quarter" },
          { text: "Year", id: "year" },
        ]}
      />

      <SegmentedControl
        selectedId="seg-2"
        onChange={({ detail }) => {
          if (loading) return;
          if (detail.selectedId === "prev" || detail.selectedId === "next") {
            handlePeriodChange(detail.selectedId);
          }
        }}
        label="Period navigation"
        options={[
          { text: "<", id: "prev" },
          {
            text:
              viewMode === "quarter"
                ? formatQuarterHeader(getStartOfQuarter(activeDate))
                : viewMode === "month"
                  ? `${activeDate.toLocaleString("default", {
                      month: "long",
                    })} ${activeDate.getFullYear()}`
                  : activeDate.getFullYear().toString(),
            id: "seg-2",
          },
          { text: ">", id: "next" },
        ]}
      />
    </SpaceBetween>
  );
};

export default PeriodFilterControls;
